import { useEffect, useState } from 'react'

export const useCarouselSlider = () => {
  const [currentCardIndex, setCurrentCardIndex] = useState<number>(0)

  const handleSlideCards = () => {
    const elementId = `carousel-item-${currentCardIndex}`
    const element = document.getElementById(elementId)
    const container = document.getElementById('slider-section')

    if (!element || !container) return

    const elementRect = element.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()

    const getCenteredElementPosition = () =>
      elementRect.left +
      container.scrollLeft -
      containerRect.left -
      containerRect.width / 2 +
      elementRect.width / 2

    const centeredPositionOfElement = getCenteredElementPosition()

    container.scrollTo({ left: centeredPositionOfElement })
    setCurrentCardIndex(currentCardIndex)
  }

  useEffect(handleSlideCards, [currentCardIndex])

  const handleChangeSlide = (index: number) => {
    setCurrentCardIndex(index)
  }

  return { handleChangeSlide, currentCardIndex }
}
